<template>
  <ion-page class="ion-page" id="main">
    <default-header>
      <template>
        <ion-title v-show="!$root.isMobileOrSmall">{{ $t('ncrypt.login_page.title') }}</ion-title>
      </template>
    </default-header>

    <ion-content class="bg-image" fullscreen>
      <background slot="fixed"/>

      <flash-messages/>
      <login/>

    </ion-content>
  </ion-page>
</template>

<script>
import Login from "../../components/auth/Login";
import FlashMessages from "../../components/ui-elements/FlashMessages";
import DefaultHeader from "../../components/nav/DefaultHeader";
import Background from "../Background";

export default {
  components: {Background, DefaultHeader, FlashMessages, Login},
}
</script>
